export default class References {
    constructor() {
        if($('.ref-button')[0]) {
            $('.ref-button').on('click', function(e) {
                e.preventDefault();
                var target = $(this).attr('href');

                if($('.reference-accordion-button').attr("aria-expanded")=='true') {
                    $('html, body').animate({
                        'scrollTop': $(target).offset().top - 170,
                    }, 500);
                } else {
                    $('.reference-accordion-button').removeClass('collapsed');
                    $('.reference-accordion-button').prop('aria-expanded', 'true');
                    $('.reference-accordion-button').attr('aria-expanded', 'true');
                    $('#reference-accordion-body').addClass('show');

                    $('html, body').animate({
                        'scrollTop': $(target).offset().top - 170,
                    }, 500);
                }
            });
        }
    }
}

new References();


// WEBPACK FOOTER //
// ../views/modules/references/assets/js/references.js